import React from "react";
import Header from "./Header";

const Thankyou = () => {
  return (
    <div className="text-center">
      {/* <div className="d-flex justify-content-center mb-4">
        <div className="icon-box bg-opacity-10 text-success rounded-circle p-3">
          <i className="bi bi-check-circle-fill fs-3"></i>
        </div>
      </div> */}
      <div className="box_thankyou">
        <h3 className="fw-bold mb-3 mt-3">Thank You!</h3>
        <h5 className="mb-4">Your assessment has been submitted</h5>
        <p className="text-muted mb-4">
          Our team will review your assessment and get back to you shortly.
        </p>
      </div>
    </div>
  );
};

export default Thankyou;
